import React from "react";
import PropTypes from "prop-types";
import {useDispatch} from "react-redux";
import UrProvider from "@mnjsplatform/data/lib/api/UrProvider";

const RadioGroupJson = (props) => {
    const dispatch = useDispatch();
    const onChanged = async (value) => {
        await dispatch(props.dataItem.setField(props.rowIndex, props.fieldInfo.Name, value));
        if (props.onChanged) {
            props.onChanged();
        }
    };
    const urProcessed = props.dataItem.rawData.ColumnUpdateRules[props.fieldInfo.Name];
    const urProvider = new UrProvider(urProcessed);
    const params = urProvider.getParamsForExecRules(props.dataItem, props.rowIndex);
    const dataRawJson = params["DataSourceJson"];
    if (!dataRawJson)
        return null;

    const meta = JSON.parse(dataRawJson);
    const arr = meta.map(r => {
        return {
            value: r.Id.toString(),
            text: r.Title
        };
    });

    const strValue = (typeof props.value !== "undefined" && props.value !== null)
        ? props.value.toString()
        : null;

    return <>{arr.map(rb => {
        const controlId = `control_${props.fieldInfo.Name}_${rb.value}`;
        return <label className={`form-check-label -inputview mr-1`} style={{cursor: "pointer"}}
                      key={`label_${props.fieldInfo.Name}_${rb.value}`}
                      htmlFor={controlId}
                      onClick={() => onChanged(rb.value)}>
            <input className="form-check-input" type="radio" name={props.fieldInfo.Name}
                   id={controlId}
                   value={rb.value}
                   checked={strValue === rb.value}
                   onChange={() => {
                   }}
                   readOnly={props.readOnly}
                   disabled={props.readOnly}
            />
            <i className="zmdi zmdi-circle"/>
            {rb.text}
        </label>
    })}</>;
}

RadioGroupJson.propTypes = {
    dataItem: PropTypes.object.isRequired,
    fieldInfo: PropTypes.object.isRequired,
    rowIndex: PropTypes.number.isRequired,
    readOnly: PropTypes.bool,
    value: PropTypes.any,
    onChanged: PropTypes.func
};

export default RadioGroupJson;